import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";

import { MyOffersLobbyComponent } from "./my-offers-lobby.component";
import { MyOffersLobbyEffects } from "./my-offers-lobby.effects";

@NgModule({
	declarations: [MyOffersLobbyComponent],
	imports: [CommonModule, EffectsModule.forFeature(MyOffersLobbyEffects)],
	exports: [MyOffersLobbyComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MyOffersLobbyModule {}
